import { ReactElement } from 'react';

import { AgentAreaOptimized } from '../pages/private/agentArea/AgentAreaOptimized';
import { AnchoringWindow } from '../pages/private/anchoringWindow/AnchoringWindow';
import { Dashboard } from '../pages/private/dashboard/Dashboard';
import { IntegrationsHealth } from '../pages/private/integrationsHealth/IntegrationsHealth';
import { Invoicing } from '../pages/private/invoicing/Invoicing';
import { ManoeuvreBoard } from '../pages/private/manoeuvreBoard/ManoeuvreBoard';
import { OperatiorArea } from '../pages/private/operatorArea/OperatorArea';
import { Permissions } from '../pages/private/permissions/Permissions';
import { PumpWindow } from '../pages/private/pumpWindow/PumpWindow';
import { ReadingInvoices } from '../pages/private/readingInvoices/ReadingInvoices';
import { Registers } from '../pages/private/registers/Registers';
import { Reports } from '../pages/private/reports/Reports';
import { StaymentOptimized } from '../pages/private/stayment/StaymentOptimized';
import { StopoverOptimized } from '../pages/private/stopover/StopoverOptimized';
import { Storage } from '../pages/private/storage/Storage';
import { WarehousingVehicles } from '../pages/private/warehousingVehicles/WarehousingVehicles';

/**
 * Static catalogue of the system's private pages.
 *
 * Each `key` mirrors a backend `SectionKey` (core/infrastructure/models/section.py)
 * — that string is the immutable contract that gates access. A user can open a
 * route only when its `key` is among the sections reachable through their groups
 * (GET /core/auth/user/sections), or when they are an admin (sees everything).
 *
 * Sub-routes that share access with a parent page repeat the parent's `key`
 * (e.g. the vehicle-warehousing operator area is gated by `warehousing/vehicles`).
 *
 * NOTE: `/settings/security` is intentionally NOT listed here — account security
 * is available to any authenticated user and is wired directly in routes.tsx.
 */
export type ProtectedRoute = {
  path: string;
  key: string;
  element: ReactElement;
};

export const protectedRoutes: ProtectedRoute[] = [
  { path: '/dashboard', key: 'dashboard', element: <Dashboard /> },
  { path: '/reports', key: 'reports', element: <Reports /> },
  { path: '/invoicing', key: 'invoicing', element: <Invoicing /> },
  { path: '/operator-area', key: 'operator-area', element: <OperatiorArea /> },
  { path: '/agent-area', key: 'agent-area', element: <AgentAreaOptimized /> },
  {
    path: '/stopover-management',
    key: 'stopover-management',
    element: <StopoverOptimized />,
  },
  {
    path: '/stayment-management',
    key: 'stayment-management',
    element: <StaymentOptimized />,
  },
  {
    path: '/docking-window',
    key: 'docking-window',
    element: <AnchoringWindow />,
  },
  {
    path: '/manoeuvre-board',
    key: 'manoeuvre-board',
    element: <ManoeuvreBoard />,
  },
  { path: '/pump-window', key: 'pump-window', element: <PumpWindow /> },
  {
    path: '/settings/permissions',
    key: 'settings/permissions',
    element: <Permissions />,
  },
  {
    path: '/settings/registers',
    key: 'settings/registers',
    element: <Registers />,
  },
  {
    // key SEM barra inicial: é idêntico ao SectionKey do backend.
    path: '/settings/integrations',
    key: 'settings/integrations',
    element: <IntegrationsHealth />,
  },
  {
    path: '/warehousing/vehicles',
    key: 'warehousing/vehicles',
    element: <WarehousingVehicles />,
  },
  {
    path: '/warehousing/vehicles/operator-area-warehousing',
    key: 'warehousing/vehicles',
    element: <WarehousingVehicles />,
  },
  {
    path: '/warehousing/reading-invoices',
    key: 'warehousing/reading-invoices',
    element: <ReadingInvoices />,
  },
  {
    path: '/warehousing/storage-terminal',
    key: 'warehousing/storage-terminal',
    element: <Storage />,
  },
];
